'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["slots", "slotProps", "className", "classes"];
import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { ConversationHeader } from '@mui/x-chat-headless';
import { styled, createUseThemeProps } from "../internals/zero-styled/index.mjs";
import { useChatConversationUtilityClasses } from "./chatConversationClasses.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
const useThemeProps = createUseThemeProps('MuiChatConversationHeader');
const ChatConversationHeaderStyled = styled('header', {
  name: 'MuiChatConversation',
  slot: 'Header',
  overridesResolver: (_, styles) => styles.header
})(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(1.5, 2),
  borderBottom: '1px solid',
  borderBottomColor: (theme.vars || theme).palette.divider,
  backgroundColor: (theme.vars || theme).palette.background.paper,
  flexShrink: 0,
  minHeight: 56,
  boxSizing: 'border-box'
}));
const ChatConversationHeader = /*#__PURE__*/React.forwardRef(function ChatConversationHeader(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiChatConversationHeader'
  });
  const {
      slots,
      slotProps,
      className,
      classes: classesProp
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  const classes = useChatConversationUtilityClasses(classesProp);
  return /*#__PURE__*/_jsx(ConversationHeader, _extends({}, other, {
    slots: _extends({
      header: slots?.header ?? ChatConversationHeaderStyled
    }, slots),
    slotProps: _extends({}, slotProps, {
      header: _extends({
        ref,
        className: clsx(classes.header, className)
      }, slotProps?.header)
    })
  }));
});
if (process.env.NODE_ENV !== "production") ChatConversationHeader.displayName = "ChatConversationHeader";
process.env.NODE_ENV !== "production" ? ChatConversationHeader.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  children: PropTypes.node,
  classes: PropTypes.object,
  className: PropTypes.string,
  slotProps: PropTypes.object,
  slots: PropTypes.object
} : void 0;
export { ChatConversationHeader };